import React from "react";
import AboutSection from "./AboutSection/AboutSection";
import MarqueeSection from "./MarqueeSection/MarqueeSection";
import StrengthStats from "./StrengthStats/StrengthStats";
import HeroSection from "./HeroSection/HeroSection";
import HowWeWork from "./HowWeWork/HowWeWork";
import BrandMarquee from "./BrandMarquee/BrandMarquee";
import OurServices from "./OurServices/OurServices";
import OurWorks from "./OurWorks/OurWorks";
import YourProjectContect from "./YourProjectContect/YourProjectContect";
import Testimonial from "./Testimonial/Testimonial";
import FAQ from "./FAQSection/FAQ";

const LandingPage = () => {
  return (
    <>
      <HeroSection />
      <MarqueeSection />
      <AboutSection />
      <StrengthStats />
      <BrandMarquee />
      <OurServices />
      <HowWeWork />
      <OurWorks />
      <Testimonial />
      <FAQ />
      <YourProjectContect />
    </>
  );
};

export default LandingPage;
